<template>
  <common-dialog
    :show.sync="innerVisible"
    :title="`选择飞猪文件 - ${materialName}`"
  >
    <div class="fliggy-select-file-dialog-body">
      
      <div v-show="materialList.length" class="material-box">
        <div class="nav-box base-scroller">
          <div
            class="nav-item"
            v-for="(item, index) in materialList"
            :key="index"
            :class="{active: activeIndex === index}"
            @click="onClickNav(index)"
          >
             <div class="name-text">{{item.material_name}}</div>
             <div class="num-text">（{{item.urlList.length}}）</div>
          </div>
        </div>
        <div class="material-body base-scroller" ref="scrollEl">
          <div class="material-list">
            <div
              class="material-item"
              :class="[`material-item-${index}`]"
              v-for="(item, index) in materialList"
              :key="index"
            >
              <div class="item-header">
                <div class="header-name">
                  {{item.material_name}}（{{item.urlList.length}}）
                </div>
                <div class="check-all" v-if="!maxSelectNum">
                  <el-checkbox
                  
                    label="全选"
                    :value="materialCheckAllMap[index]"
                    @input="onSwitchAll(item, index)"
                    :disabled="disabled"
                  ></el-checkbox>
                </div>
              </div>
              <div class="material-file-list">
                <div
                  class="file-item"
                  v-for="(fileItem, index) in item.urlList"
                  :key="index"
                  
                >
                  <div class="item-img-box" @click="onPreview(fileItem.url)">
                    <img v-if="fileItem.isImage" class="item-img" :src="fileItem.url" alt="">
                    <img v-else-if="['pdf'].includes(fileItem.suffix)" class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-pdf.png" alt="">
                    <img v-else-if="['xls', 'xlsx'].includes(fileItem.suffix)" class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-xlsx.png" alt="">
                    <img v-else-if="['doc', 'docx'].includes(fileItem.suffix)" class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-doc.png" alt="">
                    <img v-else class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-file.png" alt="">
                  </div>
                  

                  <div class="item-checkbox" @click.stop="() => {}">
                    <el-checkbox
                      :disabled="fileItem.disabled || (disabled && !selectedUrlList.includes(fileItem.url))"
                      :value="selectedUrlList.includes(fileItem.url)"
                      @input="onSwitchSelectUrl(fileItem.url)"
                    ></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="nodata" v-if="!materialList.length">
        <img class="nodata-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/select-file-nodata.png" alt="">
        <div class="nodata-text">当前无可选择的文件</div>
      </div>
      
    </div>

    <div class="dialog-footer" slot="footer">
      <button @click="innerVisible = false" class="s-btn btn-info btn-lg">取消</button>
      <button @click="onSubmit" class="s-btn btn-blue btn-lg" :disabled="!selectedUrlList.length">确定</button>
    </div>
  </common-dialog>
</template>

<script>
import CommonDialog from '@/components/common/modals/common-dialog/common-dialog.vue';
import fileService from '../../../services/file-service';
import imageService from '../../../services/image-service';
import Http from '@/libs/http';

export default {
  components: {
    CommonDialog,
  },
  props: {
    visible: Boolean,
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    supportPdf: Boolean,
    materialName: String,
    maxSelectNum: Number,
  },
  data() {
    return {
      materialList: [],
      selectedUrlList: [],
      activeIndex: 0,
      materialCheckAllMap: {},
      submitting: false,
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    disabled() {
      if (!this.maxSelectNum) return false;
      return this.selectedUrlList.length >= this.maxSelectNum;
    },
  },
  watch: {
    innerVisible(value) {
      if (value) {
        this.init();
      }
    },
    selectedUrlList: {
      handler() {
        // 处理全选
        const materialCheckAllMap = {};
        this.materialList.forEach((item, index) => materialCheckAllMap[index] = item.urlList.every(item => item.disabled || this.selectedUrlList.includes(item.url)) && item.urlList.some(item => this.selectedUrlList.includes(item.url)));
        this.materialCheckAllMap = materialCheckAllMap;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
  },
  methods: {
    init() {
      if (!this.applicant.ota_material_set || !this.applicant.ota_material_set.material_list) return;
      this.selectedUrlList = [];
      this.activeIndex = 0;
      this.materialCheckAllMap = {};

      if (this.applicant.ota_material_set && this.applicant.ota_material_set.material_list && this.applicant.ota_material_set.material_list.length) {
        this.materialList = this.applicant.ota_material_set.material_list.map(item => ({
          ...item,
          urlList: item.url_set.map((url) => {
            const { suffix, filename } = fileService.getFileNameAndSuffixByUrl(url);
            const allowSuffix = this.supportPdf ? ['pdf', 'png', 'jpg', 'jpeg'] : ['png', 'jpg', 'jpeg'];
            // 文件格式是否支持
            const isAllow = suffix && allowSuffix.includes(suffix.toLocaleLowerCase());
            return {
              url,
              suffix: suffix ? suffix.toLocaleLowerCase() : '',
              filename,
              disabled: !isAllow,
              isImage: imageService.isImage(url, 'url'),
            };
          }),
        }));
      } else {
        this.materialList = [];
      }
      
      
      this.$nextTick(() => {
        this.initScroll();
      });
    },

    initScroll() {
      if (!this.$refs.scrollEl) return;
      this.$refs.scrollEl.removeEventListener('scroll', this.computedActiveNav);
      this.$refs.scrollEl.addEventListener('scroll', this.computedActiveNav);
    },
    computedActiveNav() {
      if (!this.$refs.scrollEl) return;
      try {
        // 本质上就是从上往下找，然后找到最后一个锚点元素top小于0的，也就是当前激活的。
        let activeIndex = 0;

        const scrollTop = this.$refs.scrollEl.scrollTop;
        for (let index = 0; index < this.materialList.length; index++) {
          const groupEl = this.$refs.scrollEl.querySelector(
            `.material-item-${index}`,
          );
          if (groupEl.offsetTop - 5 < scrollTop) {
            activeIndex = index;
          } else {
            break;
          }
        }

        this.activeIndex = activeIndex;
      } catch (error) {
        //
        console.log(error);
      }
    },
    onClickNav(index) {
      if (!this.$refs.scrollEl) return;
      const el = this.$refs.scrollEl.querySelector(
        `.material-item-${index}`,
      );
      this.activeIndex = index;
      if (!el) return;
      this.$refs.scrollEl.scrollTo({
        top: el.offsetTop,
        behavior: 'smooth',
      });
    },

    onPreview(url) {
      if (imageService.isImage(url, 'url')) {
        this.$viewerApi({
          images: [url],
        });
        return;
      }
      window.open(url);
    },
    onSwitchAll(item, index) {
      const isSelectAll = this.materialCheckAllMap[index];
      item.urlList.forEach((fileItem) => {
        if (fileItem.disabled) return;
        const index = this.selectedUrlList.indexOf(fileItem.url);
        if (isSelectAll) {
          // 删除对应的
          const index = this.selectedUrlList.indexOf(fileItem.url);
          if (index > -1) this.selectedUrlList.splice(index, 1);
        } else if (index === -1) {
          // 没有则新增
          this.selectedUrlList.push(fileItem.url);
        }
      });
    },
    onSwitchSelectUrl(url) {
      const index = this.selectedUrlList.indexOf(url);
      if (index > -1) {
        this.selectedUrlList.splice(index, 1);
      } else {
        this.selectedUrlList.push(url);
      }
    },
    async onSubmit() {
      try {
        if (!this.selectedUrlList.length) return;
        if (this.submitting) return;
        this.submitting = true;
        const { result } = await Http.post('/ota_material_url_to_key', {
          url_set: this.selectedUrlList,
        });
        this.submitting = false;
        this.innerVisible = false;
        this.$emit('confirm', { key_list: result });
      } catch (error) {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fliggy-select-file-dialog-body{
  .material-box{
    display: flex;
    height: calc(~'90vh - 150px');
    .nav-box{
      width: 180px;
      border-right: 1px solid #DEE2E6;
      overflow: auto;
      flex-shrink: 0;
      .nav-item{
        width: 100%;
        min-height: 48px;
        display: flex;
        align-items: center;
        padding: 4px 12px 4px 24px;
        color: #2F333D;
        font-size: 16px;
        line-height: 20px;
        cursor: pointer;
        &.active{
          background: rgba(89, 159, 255, 0.06);
          color: #599FFF;
        }
        .name-text{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .num-text{
          flex-shrink: 0;
        }
      }
    }
    .material-body{
      overflow: auto;
      flex-grow: 1;
      .material-list{
        padding: 24px;
        .material-item{
          margin-bottom: 24px;
          &:last-child{
            margin-bottom: 0;
          }
          .item-header{
            display: flex;
            align-items: flex-start;
            .header-name{
              display: inline-flex;
              align-items: center;
              color: #333333;
              font-size: 14px;
            }
            .check-all{
              margin-left: 10px;
              display: inline-flex;
              align-items: center;
            }
          }
          .material-file-list{
            margin-top: 16px;
            display: flex;
            flex-wrap: wrap;
            gap: 16px 16px;
            .file-item{
              width: 96px;
              height: 96px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              border: 1px solid #E9EEF2;
              border-radius: 4px;
             
              .item-checkbox{
                position: absolute;
                left: 4px;
                top: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .item-img-box{
                display: flex;
                align-items: center;
                justify-content: center;
                 cursor: pointer;
                .item-img{
                  width: 80px;
                  height: 80px;
                  object-fit: cover;
                }
              }
              
            }
          }
        }
      }
      
    }
  }
  .nodata{
    padding: 100px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .nodata-img{
      width: 125px;
    }
    .nodata-text{
      color: #6F6F6F;
      font-size: 14px;
      margin-top: 24px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/upload/ota/fliggy-select-file-dialog.vue